import { FontColorEnum, FontSizeEnum, Typography } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

type OptionsStatus = {
  isFetching: boolean;
  isError: boolean;
  /** Whether no active option is listed, whatever selected values are listed alongside. */
  isEmpty: boolean;
};

/**
 * What an option list says about itself once loaded: whether it could not be loaded, or holds
 * nothing active. Nothing while it loads, nor when it holds active options.
 */
export function useOptionsStatusMessage({ isFetching, isError, isEmpty }: OptionsStatus) {
  const { t } = useTranslation();

  if (isFetching) return null;
  if (isError) return t('No se pudieron cargar las opciones');
  if (isEmpty) return t('Sin resultados');
  return null;
}

type OptionsFooterProps = OptionsStatus & {
  isDark?: boolean;
};

/** Tells an empty option list apart from one that could not be loaded. */
export function OptionsFooter({ isDark, ...status }: OptionsFooterProps) {
  const message = useOptionsStatusMessage(status);

  if (!message) return null;

  return (
    <Typography
      fontSize={FontSizeEnum.Xs}
      color={isDark ? FontColorEnum.Neutral : FontColorEnum.Medium}
      className="block px-size-12 py-size-8"
    >
      {message}
    </Typography>
  );
}
